module.exports = __webpack_public_path__ + "static/media/congress-splash.6650ae83.jpg";